import { useContext, useEffect } from 'react';
import { MatchContext } from './context/MatchContext';
import { MatchResiduos } from './MatchResiduos';
import { PreviaMatch } from './componentes/PreviaMatch/PreviaMatch';
import { AuthContext } from 'context';
import { PERMISOS } from 'const/Permisos';

/**
 * @name InitMatch
 * Lógica inicial donde determina que vista mostrar según si tiene negocio o no.
 */
export const InitMatch = () => {
  const {
    getDatosUsuarioConNegocio,
    handleCargarMatch,
    matchStep,
    setMatchStep
  } = useContext(MatchContext);

  const { isTieneSucursales, isTienePermisos } = useContext(AuthContext);

  const tieneNegocio = isTieneSucursales() || null;

  const cargarDatosUsuario = async () => {
    const datosUsuario = await getDatosUsuarioConNegocio();
    handleCargarMatch(datosUsuario);
  };

  useEffect(() => {
    //Si el usuario no tiene negocio Superadmin, ATerritorial, Usuario sin negocio o si el usuario es asesor de circularidad redirigimos a previa_match
    if (tieneNegocio && !isTienePermisos(PERMISOS.administracionSucursales)) {
      cargarDatosUsuario();
      return;
    }

    setMatchStep('previa_match');
  }, [tieneNegocio]);

  return (
    <div className="w-full">
      {matchStep === 'loading' && <div></div>}
      {matchStep === 'previa_match' && <PreviaMatch />}
      {matchStep === 'match' && <MatchResiduos />}
    </div>
  );
};
